export default {
    namespaced: true,
    state: {
        codigoAutorizacion: null
    },
    mutations: {
        actualizarCodigoAutorizacion(state, codigoAutorizacion) {
            state.codigoAutorizacion = codigoAutorizacion;
        },
        resetearCodigoAutorizacion(state){
            state.codigoAutorizacion = null
        }
    },
    actions: {
        actualizarCodigoAutorizacion({
            commit
        }, payload) {
            commit("resetearCodigoAutorizacion", null);
            commit("actualizarCodigoAutorizacion", payload);
        }
    }
}
